import { render, staticRenderFns } from "./ResidentialAccount.vue?vue&type=template&id=849bcae6"
import script from "./ResidentialAccount.vue?vue&type=script&lang=js"
export * from "./ResidentialAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports